import { User } from '@typing/global';
import axios from 'axios';
import envConfig from '../../environment';
import storage from '@utils/storage';
import { useMutation, MutationOptions } from 'react-query';
import { ExtractFnReturnType } from '../../lib/react-query';

export type ChangePassword = {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export const getUser = (id: string): Promise<User> => {
  return axios.get(`${envConfig.apiUrl}/user/${id}`, {
    headers: {
      authorization: `Bearer ${storage.getToken()}`,
      Accept: 'application/json',
    },
  });
};

export const updateUser = (payload: any): Promise<User> => {
  return axios.put(`${envConfig.apiUrl}/profile`, payload, {
    headers: {
      authorization: `Bearer ${storage.getToken()}`,
      Accept: 'application/json',
    },
  });
};

export const uploadProfileImage = (payload: FormData): Promise<User> => {
  return axios.put(`${envConfig.apiUrl}/profile/profile-image`, payload, {
    headers: {
      authorization: `Bearer ${storage.getToken()}`,
      Accept: 'application/json',
    },
  });
};

export const changePassword = (data: ChangePassword): Promise<User> => {
  return axios.put(`${envConfig.apiUrl}/admin/change-password`, data, {
    headers: {
      authorization: `Bearer ${storage.getToken()}`,
      Accept: 'application/json',
    },
  });
};

export const updateAdminProfile = (payload: { email: string }): Promise<User> => {
  return axios.put(`${envConfig.apiUrl}/admin/profile`, payload, {
    headers: {
      authorization: `Bearer ${storage.getToken()}`,
      Accept: 'application/json',
    },
  });
};

type UpdateAdminProfileFnType = typeof updateAdminProfile;
type ChangePasswordFnType = typeof changePassword;

export const useUpdateAdminProfileMutation = (
  options: MutationOptions<Awaited<ReturnType<UpdateAdminProfileFnType>>, unknown, Parameters<UpdateAdminProfileFnType>[0]>
) => {
  return useMutation<Awaited<ReturnType<UpdateAdminProfileFnType>>, unknown, Parameters<UpdateAdminProfileFnType>[0]>({
    mutationFn: updateAdminProfile,
    ...options,
  });
};

export const useChangePasswordMutation = (
  options: MutationOptions<Awaited<ReturnType<ChangePasswordFnType>>, unknown, Parameters<ChangePasswordFnType>[0]>
) => {
  return useMutation<Awaited<ReturnType<ChangePasswordFnType>>, unknown, Parameters<ChangePasswordFnType>[0]>({
    mutationFn: changePassword,
    ...options,
  });
};
